<template>
  <div class="container">
    <Header />
    <br /><br /><br /><br /><br /><br />
    <h3>Frequently Asked Questions</h3>
    <br />
    <h5>
    Q: How can I contact Froot Brand ?<br />
    A: Send a text to (XXX) 555-5555<br />
    <br />

    </h5>
    <br />
    <Footer />
  </div>
</template>

<script>

import Header from "../components/header";
import Footer from "../components/footer";

import {mapGetters} from "vuex";


export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapGetters({
    })
  },
  data() {
    return {
    };
  },
  methods:{
  },
};
</script>
